import { createAction, union, props } from '@ngrx/store';

import { Modal } from '../../interfaces/modal.interface';

export const openModal = createAction('[One Upgrade Modal] open', props<{ modal: Modal; returnTarget: string }>());
export const closeModal = createAction('[One Upgrade Modal] close');
export const confirmModal = createAction('[One Upgrade Modal] confirm');

const all = union({ openModal, closeModal, confirmModal });
export type ModalActionsUnion = typeof all;
